
const commercialStore = {
  namespaced: true,
  state: () => ({
    isWhiteList: false,
  }),
  getters: {
    isWhiteList(state) {
      return state.isWhiteList || false;
    },
  },
  mutations: {
    setIsWhiteList(state, isWhiteList) {
      state.isWhiteList = isWhiteList;
    },
  },
  actions: {
    initCommercialWhiteList(context) {
      // 全量放开白名单，qq小程序暂不放开白名单
      context.commit('setIsWhiteList', process.env.UNI_PLATFORM !== 'mp-qq');
    },
  },
};

export default commercialStore;
